// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__3_dkp","errorLogs":"styles_errorLogs__hQK_O"};